import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* Desktop Nav Links — LEFT */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { id: "home", label: "Home" },
            { id: "about", label: "About" },
            { id: "links", label: "Links" },
            { id: "pricing", label: "Pricing" },
            { id: "contact", label: "Contact" },
          ].map((s) => (
            <button
              key={s.id}
              onClick={() => scrollTo(s.id)}
              className="text-sm text-slate-500 hover:text-[#0f2559] font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {s.label}
            </button>
          ))}
        </div>

        {/* CTA — CENTER (desktop) */}
        <div className="hidden md:block">
          <button
            onClick={() => scrollTo("contact")}
            className="bg-[#0f2559] hover:bg-[#1a3a6e] text-white text-sm font-semibold px-5 py-2 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Get in Touch
          </button>
        </div>

        {/* Logo + Brand — RIGHT */}
        <div
          className="hidden md:flex items-center gap-3 cursor-pointer"
          onClick={() => scrollTo("home")}
        >
          <span className="text-[#0f2559] font-extrabold text-2xl tracking-tight">Agent Ben</span>
          <div className="w-12 h-12 flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/b0dfad47411a5cab4bb37e29cd654d91/ad7ef5d5c8ae0c30ee62e19ca8db67c2.png"
              alt="Agent Ben Logo"
              className="w-12 h-12 object-contain rounded-full"
            />
          </div>
        </div>

        {/* Mobile: brand left, hamburger right */}
        <div
          className="md:hidden flex items-center gap-2 cursor-pointer"
          onClick={() => scrollTo("home")}
        >
          <span className="text-[#0f2559] font-extrabold text-xl tracking-tight">Agent Ben</span>
          <div className="w-9 h-9 flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/b0dfad47411a5cab4bb37e29cd654d91/ad7ef5d5c8ae0c30ee62e19ca8db67c2.png"
              alt="Agent Ben Logo"
              className="w-9 h-9 object-contain rounded-full"
            />
          </div>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-[#0f2559] cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 px-6 py-4 flex flex-col gap-4">
          {[
            { id: "home", label: "Home" },
            { id: "about", label: "About Agent Ben" },
            { id: "links", label: "Links" },
            { id: "pricing", label: "Pricing" },
            { id: "contact", label: "Contact" },
          ].map((s) => (
            <button
              key={s.id}
              onClick={() => scrollTo(s.id)}
              className="text-slate-600 hover:text-[#0f2559] text-sm text-left cursor-pointer whitespace-nowrap font-medium"
            >
              {s.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
